// extracted by mini-css-extract-plugin
export default {"container":"_34xq97qRYoZXl9e4PXAMZJ","frame":"_3KEbu0fAFVhT4nXfAjHB7e","buttons":"_1WuI-nuvlIcT-82lYL7Ew1"};